<script setup lang="ts">
defineProps<{ compact?: boolean; inverse?: boolean }>();
</script>

<template>
  <RouterLink to="/" class="brand" :class="{ inverse, compact }" aria-label="RecruitFlow Jobs">
    <span class="brand-mark">RF</span>
    <span v-if="!compact" class="brand-copy"><strong>RecruitFlow Jobs</strong><small>Marketplace Karier Multi-Perusahaan</small></span>
  </RouterLink>
</template>
